<template>
    <div>
        <div style="padding: 5px;" class="mb-30">

            <a-skeleton :loading="requestLoading"></a-skeleton>

            <a-skeleton v-if="requestA.length != 0" :loading="requestLoading">
                <span class="font-web" :style="{ color: '#1450A3', marginBottom: '14px' }">
                    <a-icon class="mr-10" type="schedule" />การลา
                </span>
                <a-list class="mt-10 mb-20 text-dark" size="small" :data-source="requestA">
                    <a-list-item style="border-left: 5px solid #DAF5FF;" slot="renderItem" slot-scope="item, index">
                        <span class="ml-20">
                            <a-list-item-meta>
                                <div slot="description">
                                    <span style="font-size: 12px;" class="text-muted">สถานะคำขอ :
                                        <a-tag :color="item.status === 'approve' ? '#87d068' : ''"
                                            class="text-capitalize">{{
                                                item.status
                                            }}</a-tag></span>
                                </div>
                                <div slot="title">
                                    <h6 class="font-web font-weight-bold mt-5 mb-5">
                                        <a-tag :style="{ fontSize: '12px', fontWeight: '900' }">{{
                                            item.absence_type === "long_term_medical"
                                            ? "ลาระยะยาว"
                                            : item.absence_type
                                        }}
                                            จำนวน {{ item.absence_amount }} วัน</a-tag>
                                    </h6>
                                    <p style="font-size: 12px;" class="mt-10 mb-0">
                                        <span class="text-muted">วันที่ขอ&nbsp;&nbsp;&nbsp;: {{
                                            moment(item.start_date).locale('th').add(543,
                                                'year').format("DD / MMM / YYYY") }}&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;{{
            moment(item.end_date).locale('th').add(543, 'year').format("DD / MMM / YYYY")
        }}</span>
                                    </p>
                                    <p style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted">วันที่ทำรายการ&nbsp;&nbsp;&nbsp;: </span>
                                        {{ moment(item.created_at).locale('th').add(543, 'year').format("DD / MMMM / YYYY")
                                        }}
                                    </p>
                                </div>
                            </a-list-item-meta>
                        </span>
                    </a-list-item>
                </a-list>
            </a-skeleton>

            <a-skeleton v-if="requestB.length != 0" :loading="requestLoading">
                <span class="font-web" :style="{ color: '#1450A3', marginBottom: '14px' }">
                    <a-icon class="mr-10" type="issues-close" /> คำขอลืมบันทึกเวลา
                </span>
                <a-list size="small" class="mt-5 mb-20 text-dark" :data-source="requestB">
                    <a-list-item style="border-left: 5px solid #DAF5FF;" slot="renderItem" slot-scope="item, index">
                        <span class="ml-20">
                            <a-list-item-meta>
                                <div slot="description">
                                    <span style="font-size: 12px;" class="text-muted">สถานะคำขอ :
                                        <a-tag :color="item.status === 'approve' ? '#87d068' : ''"
                                            class="text-capitalize">{{
                                                item.status
                                            }}</a-tag></span>
                                </div>
                                <div slot="title">
                                    <p style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted">เวลาที่ขอลืมบันทึก เริ่มเวลา :</span>
                                        <span class="ml-5">{{ item.start_time !== null ?
                                            moment(item.start_time).locale("th").format("LTS") : "-" }}</span>
                                        <span class="ml-5 text-muted">ถึงเวลา :</span>
                                        <span class="ml-5">{{
                                            item.end_time !== null
                                            ? moment(item.end_time).locale("th").format("LTS")
                                            : "-"
                                        }}</span>
                                    </p>
                                    <p style="font-size: 12px;" class="mt-5 mb-0">
                                        <span class="text-muted">วันที่ขอ&nbsp;&nbsp;&nbsp;:
                                            {{
                                                item.start_time !== null
                                                ? moment(item.start_time).locale('th').add(543, 'year').format("DD / MMMM / YYYY") : moment(item.end_time).locale('th').add(543, 'year').format("DD / MMMM / YYYY") }}
                                        </span>
                                    </p>
                                    <p style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted">วันที่ทำรายการ&nbsp;&nbsp;&nbsp;: </span>
                                        {{ moment(item.created_at).locale('th').add(543, 'year').format("DD / MMMM / YYYY")
                                        }}
                                    </p>
                                </div>
                            </a-list-item-meta>
                        </span>
                    </a-list-item>
                </a-list>
            </a-skeleton>

            <a-skeleton v-if="requestD.length != 0" :loading="requestLoading">
                <span class="font-web" :style="{ color: '#1450A3', marginBottom: '14px' }">
                    <a-icon class="mr-10" type="file-add" /> Training / Seminar
                </span>
                <a-list size="small" class="mt-5 mb-20 text-dark" :data-source="requestD">
                    <a-list-item style=" border-left: 5px solid #DAF5FF;" slot="renderItem" slot-scope="item, index">
                        <span class="ml-20">
                            <a-list-item-meta>
                                <div slot="description">
                                    <span style="font-size: 12px;" class="text-muted">สถานะคำขอ :
                                        <a-tag :color="item.status === 'approve' ? '#87d068' : ''"
                                            class="text-capitalize">{{
                                                item.status
                                            }}</a-tag></span>
                                </div>
                                <div slot="title">
                                    <h6 class="font-web font-weight-bold mt-5 mb-5">
                                        <a-tag :style="{ fontSize: '12px', fontWeight: '900' }">{{ item.seminar_type }}
                                            จำนวน {{ item.seminar_amount }} วัน</a-tag>
                                    </h6>
                                    <p style="font-size: 12px;" class="mt-10 mb-0">
                                        <span class="text-muted">วันที่ขอ&nbsp;&nbsp;&nbsp;: {{
                                            moment(item.start_date).locale('th').add(543,
                                                'year').format("DD / MMM / YYYY") }}&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;{{
            moment(item.end_date).locale('th').add(543, 'year').format("DD / MMM / YYYY")
        }}</span>
                                    </p>
                                    <p style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted">วันที่ทำรายการ&nbsp;&nbsp;&nbsp;: </span>
                                        {{ moment(item.created_at).locale('th').add(543, 'year').format("DD / MMMM / YYYY")
                                        }}
                                    </p>
                                </div>
                            </a-list-item-meta>
                        </span>
                    </a-list-item>
                </a-list>
            </a-skeleton>

            <a-skeleton v-if="requestC.length != 0" :loading="requestLoading">
                <span class="font-web" :style="{ color: '#1450A3', marginBottom: '12px' }">
                    <a-icon class="mr-10" type="issues-close" /> Flexible
                </span>
                <a-list size="small" class="mt-5 mb-20 text-dark" :data-source="requestC">
                    <a-list-item style="border-left: 5px solid #DAF5FF;" slot="renderItem" slot-scope="item, index">
                        <span class="ml-20">
                            <a-list-item-meta>
                                <div slot="description">
                                    <span style="font-size: 12px;" class="text-muted">สถานะคำขอ :
                                        <a-tag :color="item.status === 'approve' ? '#87d068' : ''"
                                            class="text-capitalize">{{
                                                item.status
                                            }}</a-tag></span>
                                </div>
                                <div slot="title">
                                    <span style="font-size: 12px;" class="mt-10 mb-10">
                                        <a-tag class="font-web">
                                            {{
                                                item.flex_type === "full-day"
                                                ? "เต็มวัน Full Day"
                                                : item.flex_type === "am-half-day"
                                                    ? "ครึ่งวันเช้า AM : Half Day"
                                                    : "ครึ่งวันบ่าย PM : Half Day"
                                            }}
                                        </a-tag>
                                    </span>
                                    <br>
                                    <span style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted font-web">วันที่มาทำงาน :</span>
                                        {{ moment(item.selected_date).locale('th').add(543, 'year').format("DD / MMMM / YYYY") }}
                                    </span>
                                    <br>
                                    <span style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted font-web">ขอแลกวันทำงาน :</span>
                                        {{ moment(item.move_to_date).locale('th').add(543, 'year').format("DD / MMMM / YYYY") }}
                                    </span>
                                    <br>
                                    <span style="font-size: 12px;" class="mt-0 mb-0">
                                        <span class="text-muted font-web">วันที่ทำรายการ :</span>
                                        {{ moment(item.created_at).locale('th').add(543, 'year').format("DD / MMMM / YYYY") }}
                                    </span>
                                </div>
                            </a-list-item-meta>
                        </span>
                    </a-list-item>
                </a-list>
            </a-skeleton>

            <div
                v-if="(requestA.length == 0) && (requestB.length == 0) && (requestC.length == 0) && (requestD.length == 0)">
                <a-empty v-if="!requestLoading">
                    <span style="font-size: 12px;" slot="description" class="mb-20 font-web font-weight-bold text-muted">
                        ไม่พบข้อมูล คำขอ </span>
                </a-empty>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        requestLoading: {
            type: Boolean,
            default: () => (false),
        },
        requestA: {
            type: Array,
            default: () => ([]),
        },
        requestB: {
            type: Array,
            default: () => ([]),
        },
        requestC: {
            type: Array,
            default: () => ([]),
        },
        requestD: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {}
    }
}
</script>